<nav class="sidenav shadow-right" id="sidenavAccordion" [ngClass]="sidenavStyle" data-cy="sideNav">
	<div class="sidenav-menu">
		<div class="nav">
			@for (section of sideNavSections; track section) {
				@if (section.text) {
					<div class="sidenav-menu-heading">{{ section.text }}</div>
				}
				@for (item of section.items; track item) {
					<sbpro-side-nav-item [sideNavItem]="sideNavItems[item]" [isFeatherIcon]="!sideNavItems[item].iconAwesome"></sbpro-side-nav-item>
				}
				<sbpro-side-nav-item [sideNavItem]="navItemContactUs" [isFeatherIcon]="!navItemContactUs.iconAwesome"></sbpro-side-nav-item>
			}

			<a class="nav-link cursor-pointer-hover" (click)="logout(modalLogout)">
				<div class="nav-link-icon"><i-feather name="log-out"></i-feather></div>
				Sair
			</a>
		</div>
	</div>
	<div class="sidenav-footer">
		<div class="sidenav-footer-content">
			<div class="sidenav-footer-subtitle">Logado como:</div>
			<div class="sidenav-footer-title">Username</div>
		</div>
	</div>
</nav>

<ng-template #modalLogout>
	<div class="modal-content">
		<div class="modal-body text-center"></div>
	</div>
</ng-template>
